/**
 * 폼 텍스트 칸의 값.
 *
 * Owns:
 * - 빈 입력의 표현(`null`).
 *
 * Does not own:
 * - 칸마다의 유효성(공백 규칙 · 길이) — 각 도메인의 검사가 BE 규칙을 따른다.
 */

/** 빈 입력과 공백뿐인 입력은 `null` 이다. 정본(BE)은 공백뿐인 문자열을 받지 않는다. */
export function textOrNull(value: string): string | null {
  return value.trim() === "" ? null : value;
}
